import { requestWithAuth } from '@/utilities/graphQLClient';
import { gql } from 'graphql-request';

import type {
  UnmatchedHolding,
  PortfolioFragmentType,
} from '@/hooks/usePortfolio';
import { PORTFOLIO_FRAGMENT } from '@/hooks/usePortfolio';

interface QueryResponse {
  errors: Error[];
  matchUnmatchedHolding: PortfolioFragmentType;
}

export const matchUnmatchedHoldingQueryFn = async (payload: {
  id: UnmatchedHolding['id'];
  uniqueSymbol: string;
}) => {
  const { id, uniqueSymbol } = payload;
  const { matchUnmatchedHolding, errors } =
    await requestWithAuth<QueryResponse>(
      gql`
        mutation matchUnmatchedHolding($id: String!, $uniqueSymbol: String!) {
          matchUnmatchedHolding(id: $id, uniqueSymbol: $uniqueSymbol) {
            ...portfolioFields
          }
        }
        ${PORTFOLIO_FRAGMENT}
      `,
      {
        id,
        uniqueSymbol,
      }
    );

  if (errors && errors.length > 0) {
    throw new Error(errors[0].message);
  }

  return matchUnmatchedHolding;
};
